﻿import { ValgStateActionTypes, ValgState, TOGGLE_AVSTAND, TOGGLE_VILKAR, UPDATE_VALG } from './Types';

export const initialState: ValgState = {
    aAvstand: undefined,
    bReisetid: undefined,
    visAvstand: false,
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    const newState = getNewState();
    return newState;

    function getNewState(): ValgState {
        switch (action.type) {
            case UPDATE_VALG: {
                if (action.payload.aAvstand) {
                    return {
                        ...initialState,
                        ...action.payload,
                    };
                } else {
                    return {
                        ...state,
                        ...action.payload,
                    };
                }
            }
            case TOGGLE_AVSTAND: {
                return {
                    ...state,
                    visAvstand: !state.visAvstand,
                };
            }
            case TOGGLE_VILKAR: {
                return {
                    ...state,
                    visVilkar: !state.visVilkar,
                };
            }
            default:
                return state;
        }
    }
}
